import './AskModal.scss';
import Button from './Button';

const AskModal = ({
  visible,
  title,
  description,
  confirmText = '확인',
  cancelText = '취소',
  onConfirm,
  onCancel,
}) => {
  if (!visible) return null;

  return (
    <div className="Fullscreen">
      <div className="AskModal">
        <h2>{title}</h2>
        <p>{description}</p>
        <div className="buttons">
          <Button modal onClick={onCancel}>
            {cancelText}
          </Button>
          <Button modal blue onClick={onConfirm}>
            {confirmText}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AskModal;
